import { toast } from '@common/ui/general/Toast';
import { updateReferralCallbackStatus } from '~referral/stores/user';
import callbackApi from '~referral/api/callback';

const BASE_NAME = 'referral/callback';

const SCHEDULE_CALLBACK_INIT = `${BASE_NAME}/SCHEDULE_CALLBACK_INIT`;
const SCHEDULE_CALLBACK_SUCCESS = `${BASE_NAME}/SCHEDULE_CALLBACK_SUCCESS`;
const SCHEDULE_CALLBACK_ERROR = `${BASE_NAME}/SCHEDULE_CALLBACK_ERROR`;
const TRACK_POST_STATUS_INIT = `${BASE_NAME}/TRACK_POST_STATUS_INIT`;
const TRACK_POST_STATUS_SUCSESS = `${BASE_NAME}/TRACK_POST_STATUS_SUCSESS`;
const TRACK_POST_STATUS_ERROR = `${BASE_NAME}/ TRACK_POST_STATUS_ERROR`;
const CREATE_RCB_SOURCE_SUCCESS = `${BASE_NAME}/ CREATE_RCB_SOURCE_SUCCESS`;
const TOGGLE_PROGRAM_SELECT = 'referrals/home/TOGGLE_PROGRAM_SELECT';

export function scheduleCall(source, handleCloseModal) {
  return async dispatch => {
    dispatch({ type: SCHEDULE_CALLBACK_INIT });
    try {
      const json = await callbackApi.requestCallback(source);
      if (json.success) {
        toast.show({
          message: 'Our team will reach out to you!',
          type: 'success',
        });
        dispatch({ type: SCHEDULE_CALLBACK_SUCCESS });
        dispatch(updateReferralCallbackStatus('requested'));
        if (handleCloseModal) {
          handleCloseModal();
        }
      } else {
        toast.show({
          message: json.error,
          type: 'error',
        });
      }
    } catch (error) {
      toast.show({
        message: error,
        type: 'error',
      });
      dispatch({ type: SCHEDULE_CALLBACK_ERROR, payload: error });
    }
  };
}

export function fetchRcbSource(source) {
  if (!source) return null;
  return { type: CREATE_RCB_SOURCE_SUCCESS, payload: source };
}

export function trackPostStatus(source) {
  return async dispatch => {
    dispatch({ type: TRACK_POST_STATUS_INIT });
    const eligibleForCoins = 'eligible_for_coins';
    try {
      const json = await callbackApi.trackPostStatus(source);
      dispatch({
        type: TRACK_POST_STATUS_SUCSESS,
        paylod: json?.[eligibleForCoins],
      });
    } catch (error) {
      toast.show({
        message: 'error',
        type: 'error',
      });
      dispatch({ type: TRACK_POST_STATUS_ERROR });
    }
  };
}

export function toggleReferralProgramSelect(value) {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_PROGRAM_SELECT, value });
  };
}


const initialState = {
  isLoading: false,
  isCoinDataLoading: true,
  coinSharedData: false,
  coinSharedDataError: null,
  rcbSource: null,
  showReferralProgramSelect: true,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SCHEDULE_CALLBACK_INIT:
      return { ...state, isLoading: true };
    case SCHEDULE_CALLBACK_SUCCESS:
      return { ...state, isLoading: false };
    case SCHEDULE_CALLBACK_ERROR:
      return { ...state, isLoading: false };
    case CREATE_RCB_SOURCE_SUCCESS:
      return { ...state, rcbSource: action.payload };
    case TRACK_POST_STATUS_INIT:
      return {
        ...state, isCoinDataLoading: true,
      };
    case TRACK_POST_STATUS_SUCSESS:
      return {
        ...state, isCoinDataLoading: false, coinSharedData: action.paylod,
      };
    case TRACK_POST_STATUS_ERROR:
      return {
        ...state, coinSharedDataError: action.payload,
      };
    case TOGGLE_PROGRAM_SELECT:
      return {
        ...state,
        showReferralProgramSelect: action.value,
      };
    default:
      return state;
  }
}
